import React, { Component } from "react";
import styles from "./routes.module.scss";
import { TextField } from "@material-ui/core";
import { withLogisticRoutes } from "../../../shared/containers/containerLogisticRoutes";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { withLogisticControlPoints } from "../../../shared/containers/containerLogisticControlPoints";
import FilterAndSearchTools from "../FilterTools/FilterAndSearchTools";
import Scrollbars from "react-custom-scrollbars-2";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import { states } from "../../../reducers/queriesStates";
import { NavLink } from "react-router-dom";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import MiniMapControlPoint from "../ControlPoints/MiniMapControlPoint";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MapRouteView from "./MapRouteView";
import RouteControlPointsList from "./RouteControlPointsList";
import { withAuth } from "../../../shared/containers/containerAuth";
import Preloader from "../../../shared/items/static/preloader";

class CreateRoute extends Component {
  constructor(props) {
    super(props);

    this.state = {
      route: null,
      isChange: false,
      controlPointForMiniMap: null,
      isViewSelected: false,
      controlPoints: [],
    };
  }

  componentDidMount() {
    const { onGetLogisticRoute, logisticRouteDataState } = this.props;

    const routeId = window.location.pathname.replace("/logistic/routes/", "");

    if (logisticRouteDataState === states.NOT_REQUESTED && routeId !== "") {
      onGetLogisticRoute({ id: routeId });
    }
  }

  componentDidUpdate(preProps) {
    const {
      logisticSelectedRoute,
      logisticRouteDataState,
      logisticUpdateRoutesDataState,
      logisticAddControlPointRouteDataState,
      logisticDeleteControlPointRouteDataState,
    } = this.props;

    const { controlPoints } = this.state;

    if (logisticRouteDataState === states.READY && preProps.logisticRouteDataState === states.REQUEST) {
      this.setState({ route: logisticSelectedRoute });
    }

    if (logisticUpdateRoutesDataState === states.READY && preProps.logisticUpdateRoutesDataState === states.REQUEST) {
      this.setState({ route: logisticSelectedRoute, isChange: false });
    }

    if (logisticAddControlPointRouteDataState === states.READY && preProps.logisticAddControlPointRouteDataState === states.REQUEST) {
      const _controlPoints = controlPoints.length > 0 ? controlPoints.slice(1) : [];

      if (_controlPoints.length > 0) {
        this.onCheckClickhandler(_controlPoints[0], true);
      }

      this.setState({ route: logisticSelectedRoute, controlPoints: _controlPoints });
    }

    if (logisticDeleteControlPointRouteDataState === states.READY && preProps.logisticDeleteControlPointRouteDataState === states.REQUEST) {
      const _controlPoints = controlPoints.length > 0 ? controlPoints.slice(1) : [];

      if (_controlPoints.length > 0) {
        this.onCheckClickhandler(_controlPoints[0], false);
      }

      this.setState({ route: logisticSelectedRoute, controlPoints: _controlPoints });
    }

    if (logisticSelectedRoute !== null && logisticSelectedRoute.id !== undefined) {
      const routeId = window.location.pathname.replace("/logistic/routes", "");

      if (routeId === "") {
        window.location.href = window.location.pathname + `/${logisticSelectedRoute.id}`;
      }
    }
  }

  onCloseClick() {
    const { onSelectLogisticRoute, onSetViewPanel, viewPanelItems } = this.props;

    onSelectLogisticRoute(null);
    onSetViewPanel(viewPanelItems.routeList);
  }

  onHandleChangeStore(name, value, number = false) {
    const { route } = this.state;

    route[name] = number ? parseInt(value === "" || value === null ? "0" : value) : value;
    this.setState({ route: route, isChange: route.title !== "" && route.title !== null });
  }

  onSaveHandler() {
    const { onUpdateLogisticRoute } = this.props;
    const { route } = this.state;

    onUpdateLogisticRoute(route);
  }

  onAddContolPoint(controlPoint) {
    const { onAddControlPointRoute, data } = this.props;
    const { route } = this.state;

    const addPermission = data.permissions.includes(28001);

    if (addPermission) onAddControlPointRoute(route.id, controlPoint);
  }

  onDeleteControlPoint(controlPoint) {
    const { onDeleteControlPointRoute, data } = this.props;
    const { route } = this.state;

    const deletePermission = data.permissions.includes(28002);

    if (deletePermission) onDeleteControlPointRoute(route.id, controlPoint.id);
  }

  onCheckClickhandler(controlPoint, isAdd) {
    if (isAdd) {
      this.onAddContolPoint(controlPoint);
    } else {
      this.onDeleteControlPoint(controlPoint);
    }

    const { logisticSelectedRoute, onSelectLogisticRoute } = this.props;
    if (logisticSelectedRoute.geojsonData !== null) {
      logisticSelectedRoute.geojsonData = null;
      onSelectLogisticRoute(logisticSelectedRoute);
    }
  }

  onSetControlPointForMiniMap(controlPoint) {
    const { logisticSelectedRoute, onSelectLogisticRoute } = this.props;

    this.setState({ controlPointForMiniMap: controlPoint });

    logisticSelectedRoute.geojsonData = null;
    onSelectLogisticRoute(logisticSelectedRoute);
  }

  onViewRouteMap() {
    const { onGetLogisticRouteGeoJson, logisticSelectedRoute } = this.props;

    onGetLogisticRouteGeoJson({ id: logisticSelectedRoute.id });
    this.setState({ controlPointForMiniMap: null });
  }

  controlPointItemTable(controlPoint, index, isSelectedControlPoint) {
    const { controlPointForMiniMap } = this.state;
    return (
      <div
        key={controlPoint.id + index}
        className={styles.controlPointItemTable}
        style={{ backgroundColor: index % 2 === 0 ? "#90c0db18" : "white" }}
      >
        <div
          onClick={(e) => {
            e.stopPropagation();
            this.onSetControlPointForMiniMap(controlPoint);
          }}
          style={{ cursor: "pointer" }}
        >
          <TooltipWrapper title={`Просмотреть контрольную точку ${controlPoint.title}`} position="top">
            <VisibilityIcon
              fontSize="small"
              style={{ color: controlPointForMiniMap !== null && controlPointForMiniMap.id === controlPoint.id ? "#157fe1" : null }}
            />
          </TooltipWrapper>
        </div>
        <div
          onClick={(e) => {
            e.stopPropagation();
            this.onCheckClickhandler(controlPoint, !isSelectedControlPoint);
          }}
        >
          {isSelectedControlPoint ? (
            <div className={styles.container_itemChecked}>
              <CheckCircleIcon fontSize="small" />
            </div>
          ) : (
            <div className={styles.container_itemUnchecked}>
              <CheckCircleOutlineIcon fontSize="small" />
            </div>
          )}
        </div>
        <div>{controlPoint.title}</div>
        <div>{controlPoint.address}</div>
      </div>
    );
  }

  onSetIsViewSelected(isViewSelected) {
    const { logisticSelectedRoute } = this.props;

    this.setState({ isViewSelected });

    if (!isViewSelected) {
      this.setState({ route: logisticSelectedRoute });
    }
  }

  onCloseRouteMap() {
    const { logisticSelectedRoute, onSelectLogisticRoute } = this.props;

    logisticSelectedRoute.geojsonData = null;
    onSelectLogisticRoute(logisticSelectedRoute);
  }

  onClickEvery(isAdd) {
    const { logisticSelectedRoute, onSelectLogisticRoute, logisticControlPoints } = this.props;
    const { route } = this.state;

    logisticSelectedRoute.geojsonData = null;
    onSelectLogisticRoute(logisticSelectedRoute);

    const controlPoints = logisticControlPoints.filter((controlPoint) => {
      const isSome = route.controlPoints.some((x) => {
        return x.id === controlPoint.id;
      });

      if (isAdd && !isSome) {
        return true;
      }

      if (!isAdd && isSome) {
        return true;
      }

      return false;
    });

    if (controlPoints.length > 0) {
      this.setState({ controlPoints: controlPoints });
      this.onCheckClickhandler(controlPoints[0], isAdd);
    }
  }

  render() {
    const { route, isChange, controlPointForMiniMap, isViewSelected, controlPoints } = this.state;
    const { onGetControlPoints, logisticControlPoints, logisticSelectedRoute, data } = this.props;

    if (route === null) return null;

    const height = window.innerHeight > 800 ? 500 : 280;

    const routeUpdatePermission = data.permissions.includes(27005);
    const orderControlPointPermission = data.permissions.includes(28003);
    const getGeoJsonRoutePermission = data.permissions.includes(27006);

    const iaAllAdd = logisticControlPoints.every((controlPoint) => {
      return route.controlPoints.some((x) => {
        return x.id === controlPoint.id;
      });
    });

    return (
      <div className={styles.createRouteContainer}>
        <div className={styles.toolPanel}>
          <FilterAndSearchTools onFilter={onGetControlPoints} />

          <div
            onClick={() => {
              this.onCloseClick();
            }}
          >
            <TooltipWrapper title={"Закрыть"} position="left">
              <NavLink to={`/logistic/routes`}>
                <HighlightOffIcon style={{ color: "red" }} />
              </NavLink>
            </TooltipWrapper>
          </div>
        </div>

        <div className={styles.inLineToolContauiner}>
          <div className={styles.createRouteInputContainer}>
            <TextField
              id="outlined-basic"
              label="Наименование маршрута *"
              variant="outlined"
              size="small"
              fullWidth={true}
              value={route.title === null ? "" : route.title}
              onChange={(e) => {
                this.onHandleChangeStore("title", e.target.value);
              }}
            />
          </div>

          <div className={styles.createControlPointInputContainer} style={{ marginLeft: "30px" }}>
            <textarea
              style={{ width: "400px", fontFamily: "Open Sans" }}
              rows={2}
              value={route.description}
              onChange={(e) => {
                this.onHandleChangeStore("description", e.target.value);
              }}
            />
          </div>

          <div className={styles.inLineToolRightContauiner}>
            {isChange && routeUpdatePermission ? (
              <div>
                <ButtonPrimary title={"Обновить"} handleClick={this.onSaveHandler.bind(this)}></ButtonPrimary>
              </div>
            ) : null}
          </div>
        </div>

        <div className={styles.createRoutePointsListContainer}>
          {orderControlPointPermission ? (
            <div
              style={{ width: "100%", cursor: "pointer", marginBottom: "5px" }}
              onClick={() => {
                this.onSetIsViewSelected(!isViewSelected);
              }}
            >
              <input type="checkbox" checked={isViewSelected} />
              <span>
                Показать выбранное и изменить порядок контрольных точек
                {isViewSelected ? (
                  <div>
                    <b>Множественный выбор:</b> Ctrl/Shift + клик левой кнопкой мышы
                  </div>
                ) : null}
              </span>
            </div>
          ) : (
            <div></div>
          )}

          {isViewSelected ? <RouteControlPointsList /> : null}

          {!isViewSelected ? (
            <div className={styles.controlPointItemTable}>
              <div>{""}</div>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  this.onClickEvery(!iaAllAdd);
                }}
              >
                {controlPoints.length !== 0 ? (
                  <div className={styles.container_itemUnchecked}>
                    <Preloader size={16} />
                  </div>
                ) : iaAllAdd ? (
                  <div className={styles.container_itemChecked}>
                    <CheckCircleIcon fontSize="small" />
                  </div>
                ) : (
                  <div className={styles.container_itemUnchecked}>
                    <CheckCircleOutlineIcon fontSize="small" />
                  </div>
                )}
              </div>
              <div>
                <b>Наименование</b>
              </div>
              <div>
                <b>Адрес</b>
              </div>
            </div>
          ) : null}

          <div className={styles.pointsListContainer}>
            {!isViewSelected ? (
              <Scrollbars style={{ height: `${height}px` }} autoHide={false} ref="scrollbar">
                {logisticControlPoints.map((controlPoint, index = route.controlPoints.length - 1) => {
                  const isSelectedControlPoint = route.controlPoints.some((x) => {
                    return x.id === controlPoint.id;
                  });

                  return this.controlPointItemTable(controlPoint, index, isSelectedControlPoint);
                })}
              </Scrollbars>
            ) : null}
          </div>

          {!isViewSelected && getGeoJsonRoutePermission && route.controlPoints.length > 1 ? (
            <div
              className={styles.seeRouteButtonContainer}
              onClick={(e) => {
                e.stopPropagation();
                this.onViewRouteMap();
              }}
            >
              <VisibilityIcon fontSize="small" /> <span>Просмотреть маршрут</span>
            </div>
          ) : null}

          {!isViewSelected &&
          logisticSelectedRoute.geojsonData !== undefined &&
          logisticSelectedRoute.geojsonData !== null &&
          logisticSelectedRoute.geojsonData.routeGeometries !== null &&
          route.controlPoints.length > 1 ? (
            <div className={styles.routeMapwrapper}>
              <MapRouteView
                controlPoints={route.controlPoints}
                geojsonData={logisticSelectedRoute.geojsonData}
                height={height + 300}
                onCloseHandler={this.onCloseRouteMap.bind(this)}
              />
            </div>
          ) : null}

          {!isViewSelected && controlPointForMiniMap !== null ? (
            <MiniMapControlPoint
              controlPoint={controlPointForMiniMap}
              onSetControlPointForMiniMap={this.onSetControlPointForMiniMap.bind(this)}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

export default withAuth(withLogisticControlPoints(withLogisticRoutes(React.memo(CreateRoute))));
